import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute, DomainRedirect } from '../../../utils/domain/routingComponents'
import { caperBillingAccessControl } from '../access-control/caperBillingAccess.configuration'

const CaperBillingLandingPage = lazy(() => import('../pages/CaperBillingLandingPage'))
const CaperBillingGeneratePage = lazy(() => import('../pages/CaperBillingGeneratePage'))
const CaperBillingHistoryPage = lazy(() => import('../pages/CaperBillingHistoryPage'))
const CaperBillingRunDetailPage = lazy(() => import('../pages/CaperBillingRunDetailPage'))

export const caperBillingAdminRouter = (
  <DomainRoute route="app-admin-caper-billing" accessControl={caperBillingAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-caper-billing-generate"
        component={CaperBillingGeneratePage}
      />
      <DomainRoute
        exact
        route="app-admin-caper-billing-run-detail"
        component={CaperBillingRunDetailPage}
      />
      <DomainRoute
        exact
        route="app-admin-caper-billing-history"
        component={CaperBillingHistoryPage}
      />
      <DomainRoute exact route="app-admin-caper-billing" component={CaperBillingLandingPage} />
      <DomainRedirect toRoute="app-admin-caper-billing" />
    </DashSwitch>
  </DomainRoute>
)
